const IOS_DOWNLOAD_URL = 'https://apps.apple.com/tw/app/workute-%E5%B1%85%E5%AE%B6%E9%81%8B%E5%8B%95%E8%B6%85%E8%90%8C%E5%A4%A5%E4%BC%B4/id1617026615';
const ANDROID_DOWNLOAD_URL = 'https://play.google.com/store/apps/details?id=com.wistron.s12.fitbuddybuddy';
const CONTACT_URL = 'https://line.me/R/ti/p/@094kxmgj';
const COMPANY_PAGE = 'https://wising.ai/';
const CONSULT_SURVEY = 'https://www.surveycake.com/s/glOg2';

const VIDEO_1 = 'https://www.youtube.com/watch?v=v_5iC-cCJog';
const VIDEO_2 = 'https://youtu.be/nYovWKhvqec';
const VIDEO_CASE = 'https://www.youtube.com/watch?v=hSzMeY9zPlw';

const MEDIA_ARTICLE_1 = 'https://tw.stock.yahoo.com/news/%E8%90%BD%E5%AF%A6%E4%BC%81%E6%A5%ADesg%E7%9A%84%E5%A5%BD%E5%B9%AB%E6%89%8B-workute-ai%E9%81%8B%E5%8B%95app-%E5%93%A1%E5%B7%A5%E5%81%A5%E5%BA%B7%E4%BF%83%E9%80%B2%E7%9A%84%E7%B5%95%E4%BD%B3%E6%96%B9%E6%A1%88-023156443.html';
const MEDIA_ARTICLE_2 = 'https://www.popdaily.com.tw/life/1341073';
const MEDIA_ARTICLE_3 = 'https://running.biji.co/index.php?q=news&act=info&id=108496&subtitle=%E3%80%90%E6%B4%BB%E5%8B%95%E3%80%91%E6%89%8B%E6%A9%9F%201%20%E7%A7%92%E8%AE%8A%E8%BA%AB%E6%88%90%E6%95%99%E7%B7%B4%20Workute%20%E4%BD%A0%E7%9A%84%E5%B1%85%E5%AE%B6%E9%81%8B%E5%8B%95%E8%B6%85%E8%90%8C%E5%A4%A5%E4%BC%B4%EF%BC%81';
const MEDIA_ARTICLE_4 = 'https://tw.news.yahoo.com/%E5%85%8D%E8%B2%BB%E4%B8%8B%E8%BC%89%E9%81%8A%E7%8E%A9-%E6%9C%80%E8%90%8Cai%E9%81%8B%E5%8B%95app-%E5%B1%85%E5%AE%B6%E9%81%8B%E5%8B%95%E7%A5%9E%E5%99%A8-003050396.html';
const MEDIA_ARTICLE_5 = 'https://www.niusnews.com/=P02wg4444';
const MEDIA_ARTICLE_6 = 'https://www.upmedia.mg/news_info.php?Type=5&SerialNo=180058';
const MEDIA_ARTICLE_7 = 'https://www.nownews.com/news/6271906';
const MEDIA_ARTICLE_8 = 'https://www.facebook.com/100044141243797/posts/pfbid0mg8cAvUtRD8X9WsTMaVMdWT4WsGTqXxsFmQwvU2KED5qTwSafjjYwESKDCqFrJbcl/?mibextid=cr9u03';
const MEDIA_ARTICLE_9 = 'https://www.facebook.com/mangonursis/posts/pfbid0jahHiNti9VBAKbmMBtMPNXC6Zeev1ZCnh11ikfFZtuYGrZPFyhm49kKPRSXJLVbkl';

const CASE_ARTICLE_1 = 'https://www.linkedin.com/feed/update/urn:li:activity:7315572661810540544';
const CASE_ARTICLE_8 = 'https://www.linkedin.com/feed/update/urn:li:activity:7315582142640443392';
export {
    IOS_DOWNLOAD_URL,
    ANDROID_DOWNLOAD_URL,
    CONTACT_URL,
    COMPANY_PAGE,
    CONSULT_SURVEY,

    VIDEO_1,
    VIDEO_2,
    VIDEO_CASE,

    MEDIA_ARTICLE_1,
    MEDIA_ARTICLE_2,
    MEDIA_ARTICLE_3,
    MEDIA_ARTICLE_4,
    MEDIA_ARTICLE_5,
    MEDIA_ARTICLE_6,
    MEDIA_ARTICLE_7,
    MEDIA_ARTICLE_8,
    MEDIA_ARTICLE_9,

    CASE_ARTICLE_1,
    CASE_ARTICLE_8
};
